import { mobileFaz8De } from './mobile.faz8.de';
/** Android yönetim uygulaması metinleri (Almanca; F7-17). */
export const mobileDe = {
  ...mobileFaz8De,
  tabs: {
    home: 'Startseite',
    more: 'Mehr',
  },
  setupRequired: 'Einrichtung erforderlich',
  help: {
    longPressHint: 'Für eine Erklärung lange drücken.',
  },
  errors: {
    network:
      'Der Server ist nicht erreichbar. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    timeout: 'Der Server hat nicht rechtzeitig geantwortet. Versuchen Sie es erneut.',
    forbidden: 'Sie haben keine Berechtigung für diese Aktion.',
    generic: 'Etwas Unerwartetes ist schiefgelaufen. Versuchen Sie es erneut.',
  },
  signIn: {
    server: 'Adresse der Verwaltung',
    serverShort: 'Verwaltung: {{host}}',
    serverInvalid: 'Geben Sie eine gültige https-Adresse ein (z. B. panel.zootopia.com.tr).',
    expired:
      'Ihre Sitzung ist abgelaufen oder wurde auf einem anderen Gerät beendet. Bitte melden Sie sich erneut an.',
    signedOut: 'Abgemeldet. Die Sitzungsdaten auf diesem Gerät wurden gelöscht.',
    forgotNeedsEmail: 'Geben Sie zuerst Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen.',
  },
  mfa: {
    backupLead:
      'Wenn Sie keinen Zugriff auf Ihre Authentifizierungs-App haben, geben Sie einen Ihrer Backup-Codes ein.',
    wrongAccount: 'Mit einem anderen Konto anmelden?',
    enrollLead:
      'Für die Verwaltung ist die Zwei-Faktor-Authentifizierung erforderlich. Öffnen Sie auf diesem Telefon eine Authentifizierungs-App (Google Authenticator, Microsoft Authenticator, …), fügen Sie den Schlüssel hinzu und geben Sie den angezeigten 6-stelligen Code ein.',
    openAuthenticator: 'In Authentifizierungs-App öffnen',
    noAuthenticator: 'Keine Authentifizierungs-App gefunden. Geben Sie den Schlüssel manuell in der App ein.',
    backupWriteDown:
      'Notieren Sie die Codes auf Papier oder speichern Sie sie in Ihrem Passwort-Manager. Screenshots sind gesperrt.',
  },
  noOrganization: {
    title: 'Ihr Konto ist mit keinem Unternehmen verknüpft',
    lead: 'Ihre Mitgliedschaft wurde möglicherweise entfernt oder ausgesetzt. Bitten Sie den Administrator Ihres Unternehmens um eine Einladung.',
  },
  lock: {
    title: 'App gesperrt',
    prompt: 'Zootopia Panel entsperren',
    unlock: 'Entsperren',
    failed: 'Verifizierung fehlgeschlagen. Versuchen Sie es erneut.',
    setting: 'Biometrische Sperre',
    settingLead: 'Beim Öffnen Fingerabdruck, Gesicht oder Displaysperre abfragen',
    unavailable: 'Dieses Gerät unterstützt keine biometrische Authentifizierung.',
    notEnrolled:
      'Fügen Sie in den Telefoneinstellungen einen Fingerabdruck oder ein Gesicht hinzu und aktivieren Sie dann diese Option.',
  },
  offline: {
    banner: 'Offline — nur die Inventur auf dem Gerät kann fortgesetzt werden.',
    startup:
      'Der Server war nicht erreichbar; die App wurde mit Ihrer letzten Sitzung geöffnet. Ziehen Sie nach unten, um zu aktualisieren, sobald Sie wieder online sind.',
  },
  home: {
    today: 'Heute',
    ordersToday: 'Bestellungen',
    paidToday: 'Bezahlt',
    paidNote:
      'Summe von {{count}} heute erstellten und bezahlten Bestellungen (Erstattungen nicht abgezogen).',
    mixedCurrency: 'Zahlungen in anderen Währungen sind nicht enthalten.',
    atLeast: 'Mindestens {{count}}',
    toPrepare: 'Vorzubereiten (bezahlt)',
    returns: 'Rücksendeanfragen',
    expiring30: 'Ablauf innerhalb von 30 Tagen',
    paymentReview: 'Zahlungen in Prüfung',
    setupOnPanel: 'Die Einrichtungsschritte finden Sie im Einrichtungsassistenten der Verwaltung.',
    reportsLater:
      'Verkaufsberichte und Diagramme kommen mit dem Berichtsmodul (Phase 8). Ohne echte Daten werden keine geschätzten Zahlen angezeigt.',
  },
  orders: {
    captureNoteHint: 'Z. B. Belegnummer und Bank. Mindestens 3 Zeichen.',
    event: 'Vorgang',
  },
  returns: {
    lead: 'Tippen Sie auf eine Anfrage; die Entscheidung erfolgt im Bestellbildschirm zusammen mit Artikeln und Zahlungen.',
    empty: 'Keine Anfragen mit diesem Status',
  },
  payments: {
    empty: 'Keine Zahlungen mit diesem Status',
    reviewLead:
      'Zahlungen, deren vom Anbieter gemeldeter Betrag oder Status nicht zur Bestellung passt. Die Bestellung gilt nicht als bezahlt; Details finden Sie in der Verwaltung.',
  },
  products: {
    onHand: 'Bestand {{count}}',
    edit: 'Produkt bearbeiten',
    longTextOnPanel:
      'Langbeschreibung, Optionen, Kategorien und SEO-Felder werden in der Verwaltung bearbeitet.',
    reviewedAt: 'Freigegeben am',
    assignBarcode: 'Barcode zuweisen',
    barcodeFormat: 'Ein Barcode muss aus 8–14 Ziffern bestehen.',
    barcodeSaved: 'Barcode gespeichert.',
    barcodeSavedNoGtin:
      'Barcode gespeichert. Warnung: Die Prüfziffer ergibt keine gültige GTIN; Google-Einträge können ihn ablehnen.',
    noPrice: 'Kein Preis',
    price: 'Preis ({{currency}})',
    priceInvalid: 'Der Betrag konnte nicht gelesen werden. Beispiel: 1299,90',
    priceEmptyHint: 'Wenn Sie ein leeres Feld speichern, wird der Preis aus dieser Liste entfernt.',
    priceTaxIncluded: 'Die Preise in dieser Liste enthalten MwSt.',
    priceTaxExcluded: 'Die Preise in dieser Liste verstehen sich ohne MwSt.',
    newLead:
      'Das Produkt wird als Entwurf angelegt und im Shop nicht angezeigt. Fügen Sie Fotos, Preise und Inhalte hinzu; tierärztliche Freigabe und Veröffentlichung erfolgen im Produktbildschirm.',
    created: 'Produkt als Entwurf erstellt',
    healthOn: 'Zusammensetzung, Anwendung und Warnhinweise durchlaufen die tierärztliche Freigabe.',
    healthOff:
      'Keine gesundheitsbezogenen Inhalte (z. B. Zubehör); keine tierärztliche Freigabe erforderlich.',
  },
  photo: {
    camera: 'Foto aufnehmen',
    library: 'Aus Galerie',
    uploading: 'Bild wird hochgeladen…',
    permission:
      'Die Kameraberechtigung wurde nicht erteilt. Sie können sie in den Telefoneinstellungen erlauben.',
    tooLarge: 'Das Bild ist größer als 5 MB. Wählen Sie ein kleineres.',
  },
  scan: {
    title: 'Barcode scannen',
    button: 'Barcode scannen',
    aim: 'Barcode innerhalb des Rahmens platzieren',
    manual: 'Code eingeben',
    permissionTitle: 'Kameraberechtigung erforderlich',
    permissionLead:
      'Die Kamera wird zum Scannen von Barcodes verwendet. Bilder werden auf dem Gerät verarbeitet und nirgendwohin gesendet.',
    allow: 'Kamera erlauben',
    permissionDenied:
      'Die Kameraberechtigung ist deaktiviert. Sie können sie in den Telefoneinstellungen aktivieren.',
    openSettings: 'Einstellungen öffnen',
  },
  stock: {
    notFound: 'Kein Produkt für „{{code}}“ gefunden.',
    expired: 'Abgelaufen',
    adjustmentHint: 'Positiv zum Erhöhen, negativ (-) zum Verringern. Eine Begründung ist erforderlich.',
    dateHint: 'TT.MM.JJJJ (z. B. 31.12.2027)',
    dateInvalid: 'Das Datum konnte nicht gelesen werden. Beispiel: 31.12.2027',
    typeHints: {
      receipt: 'Neuer Bestand, der ins Lager eingeht (mit Charge und MHD).',
      adjustment: 'Korrektur einer falschen Buchung (+/−) mit Begründung.',
      damage: 'Beschädigte, verdorbene oder verlorene Artikel (werden abgezogen).',
      count: 'Die gezählte Menge wird zum neuen Gesamtbestand dieses Lagers bzw. dieser Charge.',
    },
  },
  count: {
    title: 'Inventur per Barcode',
    start: 'Inventur per Barcode',
    lead: 'Wählen Sie das Lager für die Inventur. Die Zählung wird auf dem Gerät gespeichert; Sie können auch ohne Internet weiterscannen.',
    begin: 'Inventur starten',
    lines: '{{count}} Zeilen',
    startedAt: 'Begonnen: {{date}}',
    offlineNote:
      'Sie sind offline. Gescannte Codes bleiben gespeichert; ordnen Sie sie zu und senden Sie sie, sobald Sie wieder online sind.',
    cameraOn: 'Mit Kamera scannen',
    cameraOff: 'Kamera ausschalten',
    manual: 'Barcode oder SKU eingeben',
    notFound: 'Kein Produkt für „{{code}}“ gefunden. Möglicherweise ist dem Produkt kein Barcode zugewiesen.',
    ambiguous: '„{{code}}“ passt zu mehreren Produkten; scannen Sie stattdessen per SKU.',
    savedOffline: 'Code gespeichert; er wird einem Produkt zugeordnet, sobald Sie online sind.',
    unresolved: '{{count}} Zeilen sind noch keinem Produkt zugeordnet.',
    resolve: 'Jetzt zuordnen',
    needLot: 'Wählen Sie für {{count}} Zeilen eine Charge.',
    empty: 'Noch nichts gescannt',
    emptyLead: 'Schalten Sie die Kamera ein und scannen Sie Produkt-Barcodes; jeder Scan zählt eins hinzu.',
    unknownProduct: 'Nicht zugeordneter Code',
    lineSent: 'Gesendet · neuer Gesamtbestand {{onHand}}',
    lineError: 'Nicht gesendet',
    lineUnresolved: 'Nicht zugeordnet',
    lineNeedsLot: 'Charge wählen',
    counted: 'Gezählt',
    pickLot: 'Charge wählen',
    changeLot: 'Charge ändern',
    lotLead:
      'Wählen Sie die Chargennummer, die auf den gezählten Packungen aufgedruckt ist. Die Zählung wird zum neuen Gesamtbestand dieser Charge.',
    noLots: 'In diesem Lager wurde kein Chargenbestand gefunden.',
    systemQty: '{{count}} im System',
    submit: 'Inventur senden ({{count}})',
    sent: '{{count}} Zeilen gesendet.',
    reason: 'Mobile Inventur {{date}}',
    discard: 'Inventur verwerfen',
    discardConfirm:
      'Die Inventur auf diesem Gerät wird gelöscht. Bereits gesendete Zeilen bleiben erfasst. Fortfahren?',
  },
  review: {
    title: 'Wartet auf Fachprüfung',
    detailTitle: 'Fachprüfung',
    empty: 'Nichts wartet auf Prüfung',
    count: '{{count}} Inhalte warten auf die Fachprüfung.',
    storeNote: 'Seiten, Beiträge, Banner und Fragen werden für den Shop „{{store}}“ aufgeführt.',
    inField: 'Feld: {{field}}',
    content: 'Inhalt',
    hashNote:
      'Die Freigabe bezieht sich auf den aktuellen Stand des Inhalts. Ändert er sich später, ist eine erneute Freigabe nötig; ändert er sich zwischenzeitlich, wird die Entscheidung abgelehnt und Sie werden gebeten, neu zu laden.',
    noPermission: 'Sie haben keine Berechtigung, über diesen Inhalt zu entscheiden.',
    kinds: {
      product: 'Produkt',
      post: 'Blogbeitrag',
      page: 'Seite',
      banner: 'Banner',
      question: 'Produktfrage',
    },
    bannerFields: {
      title: 'Titel',
      text: 'Text',
      ctaLabel: 'Schaltflächentext',
    },
  },
  seo: {
    title: 'SEO-Übersicht',
    noStore: 'Wählen Sie einen Shop, um die SEO-Übersicht zu sehen.',
    fixOnPanel:
      'Produkttitel und -beschreibungen korrigieren Sie im Produktbildschirm, alles andere in der Verwaltung.',
  },
  more: {
    paymentsHint: 'Zahlungen in Prüfung, ausstehend und fehlgeschlagen',
    reviewHint: 'Für die tierärztliche Fachprüfung',
    version: 'Version {{version}} · {{server}}',
  },
  notifications: {
    title: 'Push-Benachrichtigungen',
    channel: 'Bestellungen und Vorgänge',
    lead: 'Dieses Telefon wird bei Ereignissen wie einer neuen Bestellung, einer Zahlungsprüfung oder einer Rücksendeanfrage benachrichtigt. Es werden nur Ereignisse gesendet, für die Sie berechtigt sind; Benachrichtigungen enthalten keine Kundendaten.',
    device: 'Dieses Telefon',
    on: 'Ein',
    off: 'Aus',
    onLead: 'Dieses Telefon ist für Benachrichtigungen registriert.',
    askLead:
      'Erlauben Sie Benachrichtigungen auf diesem Telefon, damit Sie keine neuen Bestellungen verpassen.',
    deniedLead:
      'Die Benachrichtigungsberechtigung wurde nicht erteilt. Tippen Sie auf die Schaltfläche, um erneut gefragt zu werden.',
    blockedLead:
      'Benachrichtigungen sind in den Telefoneinstellungen deaktiviert. Aktivieren Sie sie unter Einstellungen → Benachrichtigungen für Zootopia Panel.',
    notRegisteredLead:
      'Benachrichtigungen sind erlaubt, aber dieses Telefon ist nicht registriert (entfernt oder Registrierung fehlgeschlagen).',
    allow: 'Benachrichtigungen aktivieren',
    openSettings: 'Telefoneinstellungen öffnen',
    registered: 'Benachrichtigungen sind auf diesem Telefon aktiviert.',
    registerFailed:
      'Dieses Telefon konnte nicht registriert werden. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut; besteht das Problem weiter, aktualisieren Sie die Google-Play-Dienste.',
    removeThisConfirm:
      'Dieses Telefon entfernen? Es erhält keine Benachrichtigungen mehr; tippen Sie zum erneuten Aktivieren auf „Benachrichtigungen aktivieren“.',
    deviceDisabled: 'Zustellung fehlgeschlagen',
    unsupported: 'Push-Benachrichtigungen funktionieren nur in der Android-App.',
    setupTitle: 'Diese Version hat keine Benachrichtigungseinrichtung',
    setupLead:
      'Diese App-Version wurde ohne die Firebase-Konfiguration erstellt, daher können an dieses Telefon keine Benachrichtigungen gesendet werden. Ein Administrator muss die Konfiguration auf GitHub hinzufügen und eine neue Version erstellen (Android-Build-Anleitung → Push-Benachrichtigungen).',
    meanwhile:
      'Bis dahin zeigt die Startseite, was Aufmerksamkeit erfordert; zum Aktualisieren nach unten ziehen.',
  },
  settings: {
    title: 'Einstellungen',
    signOutConfirm: 'Die Sitzung auf diesem Gerät wird beendet und ihre Daten werden gelöscht.',
    signOutPendingCount:
      'Auf diesem Gerät gibt es {{count}} nicht gesendete Inventurzeilen; sie werden gelöscht. Trotzdem abmelden?',
  },
  organization: {
    switchTitle: 'Unternehmen wechseln',
    switchConfirm:
      'Zwischengespeicherte Daten und eine nicht gesendete Inventur auf diesem Gerät werden gelöscht. Fortfahren?',
  },
};
